<template>
  <v-container>
    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-stepper v-model="numeroScheda" non-linear>
        <v-stepper-header>
          <v-stepper-step editable :complete="numeroScheda > 1" step="1"
            >Dati</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 2" step="2"
            >Configurazioni</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 3" step="3"
            >Dispositivi</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 4" step="4"
            >Conservazione</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 5" step="5"
            >Esito</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step editable :complete="numeroScheda > 6" step="6"
            >Firme</v-stepper-step
          >
        </v-stepper-header>
        <v-form v-model="form">
          <v-stepper-items>
            <!--Prima scheda - Dati generali-->
            <v-stepper-content step="1">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <DataPicker
                    label="Data verbale"
                    v-model="verbale.dataVerifica"
                  ></DataPicker>
                </v-col>
                <v-col>
                  <v-select
                    label="Verificatore"
                    outlined
                    :items="listaVerificatori"
                    item-text="name"
                    item-value="ad_user_id"
                    v-model="verbale.ad_userverificatore_id"
                    no-data-text
                    :rules="[rules.select]"
                  ></v-select>
                </v-col>
              </v-flex>
              <h4>Tipo verifica</h4>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col cols="6">
                  <v-checkbox
                    label="Prima verifica periodica"
                    v-model="verbale.verprima"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    label="Verifica di funzionamento"
                    v-model="verbale.verfun"
                  ></v-checkbox>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col cols="6">
                  <v-checkbox
                    label="Verifica interna"
                    v-model="verbale.verint"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    label="Verifica integrità"
                    v-model="verbale.verintg"
                  ></v-checkbox>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs12 sm12 md12 lg12 xl12>
                  <v-select
                    :items="tipologiaMacchinario"
                    outlined
                    label="Tipo Macchinario"
                    no-data-text="Nessun dato"
                    v-model="verbale.tipologiaMacchinario"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.select]"
                  ></v-select>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <v-select
                    outlined
                    label="Tipo"
                    v-model="verbale.tipoMacchinario"
                    :rules="[rules.select]"
                    :items="tipoMacchinario"
                    item-text="name"
                    item-value="name"
                  ></v-select>
                </v-col>
                <v-col xs2 sm2 md2 lg2 xl2>
                  <v-text-field
                    outlined
                    label="Anno"
                    v-model="verbale.anno"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs2 sm2 md2 lg2 xl2>
                  <v-text-field
                    outlined
                    label="Matricola"
                    v-model="verbale.matricola"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs2 sm2 md2 lg2 xl2>
                  <v-text-field
                    label="Marcatura CE"
                    v-model="verbale.certCE"
                    :rules="[rules.required]"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Marca"
                    outlined
                    v-model="verbale.marca"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Modello"
                    outlined
                    v-model="verbale.modello"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Numero di Fabbrica"
                    outlined
                    v-model="verbale.nFab"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col>
                  <v-text-field
                    label="Installato/utilizzato nel cantiere/stabilimento della ditta"
                    outlined
                    v-model="verbale.ditta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Comune"
                    outlined
                    v-model="verbale.comuneDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col xs4 sm4 md4 lg4 xl4>
                  <v-text-field
                    label="Via"
                    outlined
                    v-model="verbale.viaDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <!--<v-col xs1 sm1 md1 lg1 xl1>
                  <v-text-field
                    label="Numero civico"
                    outlined
                    type="number"
                    v-model="verbale.numeroCivicoDitta"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>-->
              </v-flex>
            </v-stepper-content>
            <!--Fine prima scheda-->

            <!--Seconda scheda - Titolo scheda-->
            <v-stepper-content step="2">
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <editableTable
                  :headers="headersGV"
                  v-model="verbale.generatori"
                />
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  label="Breve descrizione del funzionamento"
                  outlined
                  v-model="verbale.descFunzionamento"
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <span v-if="verbale.tipoMacchinario == 'Generatore di vapore'">
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col xs4 sm4 md4 lg4 xl4>
                    <v-text-field
                      label="Conduttore"
                      outlined
                      v-model="verbale.conduttore"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col xs4 sm4 md4 lg4 xl4>
                    <v-text-field
                      label="Abilitazione"
                      outlined
                      v-model="verbale.abilitazione"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col xs4 sm4 md4 lg4 xl4>
                    <v-text-field
                      label="Data rilascio abilitazione"
                      v-model="verbale.dataRilascioAbilitazione"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12>
                  <v-checkbox
                    label="Acqua di alimento conforme a quanto richiesto dal costruttore o della norme applicabili"
                    v-model="verbale.conformitaAcquaAlimento"
                  ></v-checkbox>
                  <v-checkbox
                    label="Imp. di riscaladamento(P>116 KW) rispettano le prescrizioni della Raccolta R dell'ISPESL"
                    v-model="verbale.conformitaImpRiscaldamento"
                  ></v-checkbox>
                </v-flex>
              </span>
            </v-stepper-content>
            <!--Fine seconda scheda-->

            <!--Terza scheda - Titolo scheda-->
            <v-stepper-content step="3">
              <v-flex xs12 sm12 md12 lg12 xl12>
                <h4>Accessori di sicurezza</h4>
                <editableTable
                  :headers="headersAccessoriSicurezza"
                  v-model="verbale.accessoriSicurezza"
                ></editableTable>
                <v-textarea
                  label="Note"
                  v-model="verbale.noteAccessoriSicurezza"
                  outlined
                  dense
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <h4>Dispositivi di controllo</h4>
                <editableTable
                  :headers="headersDispositiviControllo"
                  v-model="verbale.dispositiviControllo"
                ></editableTable>
                <v-textarea
                  label="Note"
                  v-model="verbale.noteDispositiviControllo"
                  outlined
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <h4>Dispositivi di regolazione</h4>
                <editableTable
                  :headers="headersDispositiviRegolazione"
                  v-model="verbale.dispositiviRegolazione"
                ></editableTable>
                <v-textarea
                  label="Note"
                  v-model="verbale.noteDispositiviRegolazione"
                  outlined
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  label="Accessori Rilevanti"
                  v-model="verbale.accessoriRilevanti"
                  outlined
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-textarea
                  label="Valvole di intercettazione"
                  v-model="verbale.valvoleIntercettazione"
                  outlined
                  :rules="[rules.required]"
                ></v-textarea>
              </v-flex>
            </v-stepper-content>
            <!--Fine Terza scheda-->

            <!--Quarta scheda - Stato di conservazione-->
            <v-stepper-content step="4">
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field
                  label="Verifica di visita interna generatore di vapore"
                  v-model="verbale.visitaInterna"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field
                  label="Ulteriori prove e controlli"
                  v-model="verbale.proveControlli"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field
                  label="Verifica integrità tubazioni"
                  v-model="verbale.integritaTubazioni"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field
                  label="Osservazioni"
                  v-model="verbale.osservazioni"
                  outlined
                ></v-text-field>
              </v-flex>
              <span v-if="verbale.verintg">
                <h5>Verfica integrità attrezzature:</h5>
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Esame visivo eseguito all'esterno"
                      v-model="verbale.esameVisivoEsterno"
                    ></v-checkbox>
                  </v-col>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Esame visivo eseguito dall'interno"
                      v-model="verbale.esameVisivoInterno"
                    ></v-checkbox>
                  </v-col>
                </v-flex>
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Esame spessimetrico"
                      v-model="verbale.esameSpessimetrico"
                    ></v-checkbox>
                  </v-col>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Altro"
                      v-model="verbale.altroEsame"
                    ></v-checkbox>
                  </v-col>
                </v-flex>
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col
                    cols="6"
                    xs6
                    sm6
                    md6
                    lg6
                    xl6
                    v-if="verbale.esameSpessimetrico"
                  >
                    <v-text-field
                      label="Numero esame spessimetrico"
                      v-model="verbale.nEsameSpessimetrico"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" xs6 sm6 md6 lg6 xl6 v-if="verbale.altroEsame">
                    <v-text-field
                      label="Tipo altro esame"
                      v-model="verbale.tipoAltroEsame"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-flex>
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Prova idraulica"
                      v-model="verbale.provaIdraulica"
                    ></v-checkbox>
                  </v-col>
                  <v-col xs6 sm6 md6 lg6 xl6>
                    <v-checkbox
                      label="Prova Pneumatica"
                      v-model="verbale.provaPneumatica"
                    ></v-checkbox>
                  </v-col>
                </v-flex>
                <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                  <v-col
                    cols="6"
                    xs6
                    sm6
                    md6
                    lg6
                    xl6
                    v-if="verbale.provaIdraulica"
                  >
                    <v-text-field
                      label="Pressione prova idrauilca (bar)"
                      v-model="verbale.pressioneProvaIdraulica"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    xs6
                    sm6
                    md6
                    lg6
                    xl6
                    v-if="verbale.provaPneumatica"
                  >
                    <v-text-field
                      label="Pressione prova pneumatica (bar)"
                      v-model="verbale.pressioneProvaPneumatica"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-flex>
              </span>
            </v-stepper-content>
            <!--Fine quarta scheda-->

            <!--Quinta scheda - Esito-->
            <v-stepper-content step="5">
              <h4>In base a quanto rilevato lo</h4>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-col cols="6">
                  <v-checkbox
                    label="Stato funzionamento"
                    v-model="verbale.statofunz"
                  ></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    label="Stato conservazione"
                    v-model="verbale.statocons"
                  ></v-checkbox>
                </v-col>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 class="space-up">
                <v-select
                  label="del suddetto impianto/attrezzatua,"
                  outlined
                  :items="tipoEsito"
                  v-model="verbale.esito"
                  item-value="id"
                  item-text="name"
                  :rules="[rules.select]"
                  @change="verbale.motivoRifiuto = ''"
                ></v-select>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="!esito">
                <v-text-field
                  label="Motivazione rifiuto"
                  v-model="verbale.motivoRifiuto"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6 v-if="verbale.verfun">
                  <DataPicker
                    label="Data prossima funzionamento"
                    v-model="verbale.dataProssimaFun"
                  ></DataPicker>
                </v-col>
                <v-col xs6 sm6 md6 lg6 xl6 v-if="verbale.verintg">
                  <DataPicker
                    label="Data prossima integrità"
                    v-model="verbale.dataProssimaIntg"
                  ></DataPicker>
                </v-col>
                <v-col xs6 sm6 md6 lg6 xl6 v-if="verbale.verint">
                  <DataPicker
                    label="Data prossima interna"
                    v-model="verbale.dataProssimaInt"
                  ></DataPicker>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-col xs6 sm6 md6 lg6 xl6>
                  <v-text-field
                    label="Luogo"
                    outlined
                    v-model="verbale.luogoVerifica"
                  ></v-text-field>
                </v-col>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-checkbox
                  v-model="verbale.updateScad"
                  label="Aggiorna dati sullo scadenziario"
                ></v-checkbox>
              </v-flex>
            </v-stepper-content>
            <!--Fine Quinta scheda-->

            <!--Sesta scheda - Firme-->
            <v-stepper-content step="6">
              <v-flex
                xs12
                sm12
                md12
                lg12
                xl12
                class="space-up"
                v-if="numeroScheda == 6"
              >
                <h4>Firma cliente</h4>
                <VueSignaturePad
                  style="border: 1px solid #6c757d"
                  id="firmaDatore"
                  width="702px"
                  height="180px"
                  ref="firmaDatore"
                />
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-btn color="error" @click="$refs.firmaDatore.clearSignature()"
                  >Cancella firma</v-btn
                >
              </v-flex>
              <br />
              <v-flex d-flex xs12 sm12 md12 lg12 xl12>
                <v-checkbox
                  label="Firma verificatore in affiancamento"
                  v-model="secondaFirma"
                  @change="resetSecondoVerificatore"
                ></v-checkbox>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="secondaFirma">
                <v-select
                  label="Firma verificatore"
                  outlined
                  :items="listaVerificatori"
                  item-text="name"
                  item-value="ad_user_id"
                  v-model="verbale.ad_usersecondoverificatore_id"
                  no-data-text
                  :rules="[rules.select]"
                ></v-select>
              </v-flex>
              <v-flex d-flex xs12 sm12 md12 lg12 xl12 v-if="secondaFirma">
                <v-select
                  label="Firma verificatore"
                  outlined
                  :items="listaVerificatori"
                  item-text="name"
                  item-value="ad_user_id"
                  v-model="verbale.ad_userterzoverificatore_id"
                  no-data-text
                ></v-select>
              </v-flex>
            </v-stepper-content>
          </v-stepper-items>
          <!--Fine sesta scheda-->
        </v-form>
      </v-stepper>
    </v-flex>
    <br />
    <br />
    <v-card mr-5>
      <v-footer fixed>
        <v-container>
          <v-flex d-flex>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="schedaPrecedente"
              :disabled="numeroScheda <= 1"
              >Indietro</v-btn
            >
            <v-btn
              v-if="numeroScheda < schedeTotali"
              color="primary"
              @click="schedaSuccessiva"
              >Avanti</v-btn
            >
            <v-btn
              v-else
              color="primary"
              @click="salvaVerbale"
              :disabled="!form"
              >Salva</v-btn
            >
          </v-flex>
        </v-container>
      </v-footer>
    </v-card>
    <v-dialog v-model="dialogRiepilogo" width="80%" persistent>
      <v-card>
        <v-card-title>Riepilogo</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <th>Nome verbale</th>
              <th>Data verbale</th>
              <th>Data prossima verifica funzionamento</th>
              <th>Data prossima verifica integrità</th>
              <th>Data prossima verifica interna</th>
            </thead>
            <tbody>
              <tr>
                <td>{{ riepilogo.nomeVerbale }}</td>
                <td>{{ riepilogo.dataVerifica }}</td>
                <td>{{ riepilogo.dataProxFun }}</td>
                <td>{{ riepilogo.dataProxIntg }}</td>
                <td>{{ riepilogo.dataProxInt }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <br>
          <v-alert type="warning" text v-if="isBadPayer" dense>
            Il cliente è un cattivo pagatore
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="home" text>Torna alla home</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-container>
</template>

<script>
/*eslint-disable */
import editableTable from "../components/editableTable";
import DataPicker from "../components/DataPicker";
import ConfirmDialog from "../components/ConfirmDialog";

export default {
  components: {
    editableTable,
    DataPicker,
    ConfirmDialog,
  },
  data() {
    return {
      numeroScheda: 1,
      schedeTotali: 6,
      secondaFirma: false,
      verbale: {
        dataVerifica: new Date().toISOString().substr(0, 10),
        tipologiaMacchinario: 0,
        tipoMacchinario: "",
        anno: "",
        matricola: "",
        certCE: "SI",
        marca: "",
        modello: "",
        ditta: "",
        nFab: "",
        comuneDitta: "",
        viaDitta: "",
        //numeroCivicoDitta: "",
        generatori: [],
        conduttore: "",
        abilitazione: "",
        dataRilascioAbilitazione: new Date().toISOString().substr(0, 10),
        conformitaAcquaAlimento: false,
        conformitaImpRiscaldamento: false,
        accessoriSicurezza: [],
        dispositiviControllo: [],
        dispositiviRegolazione: [],
        visitaInterna: "",
        accessoriRilevanti: "",
        valvoleIntercettazione: "",
        integritaTubazioni: "",
        osservazioni:
          "Per l’uso e la manutenzione attenersi scrupolosamente all’indicazione de costruttore nel manuale uso e/o alle norme di buona tecnica",
        esameVisivoInterno: false,
        esameVisivoEsterno: false,
        esameSpessimetrico: false,
        altroEsame: false,
        provaIdraulica: false,
        provaPneumatica: false,
        nEsameSpessimetrico: "",
        tipoAltroEsame: "",
        pressioneProvaPneumatica: "",
        pressioneProvaIdraulica: "",
        proveControlli: "",
        descFunzionamento: "",
        tipoStatoVerifica: 0,
        esito: 1000002,
        luogoVerifica: "",
        noteAccessoriSicurezza: "",
        noteDispositiviControllo: "",
        noteDispositiviRegolazione: "",
        ad_usersecondoverificatore_id: 0,
        verprima: false,
        verfun: false,
        verint: false,
        verintg: false,
        dataProssimaFun: "",
        dataProssimaInt: "",
        dataProssimaIntg: "",
        statofunz: false,
        statocons: false,
        motivoRifiuto: "",
        updateScad: true,
        ad_userverificatore_id: 0,
        ad_userterzoverificatore_id: 0,
      },
      listaVerificatori: [],
      dataProxVerIntegrita: new Date().toISOString().substring(0, 10),
      dataProxVerFunz: new Date().toISOString().substring(0, 10),
      dataProxVerInterna: new Date().toISOString().substring(0, 10),
      tipiVerifica: [],
      tipologiaMacchinario: [],
      tipoEsito: [],
      tipoStatoVerifica: [],
      tipoMacchinario: [],
      headersGV: [
        { text: "Camere", value: "camera" },
        { text: "N.F.", value: "nFab" },
        { text: "PS (bar)", value: "pressione" },
        { text: "Pes (bar)", value: "pressioneEs" },
        { text: "Volume (litri)", value: "volume" },
        { text: "Sup. m²", value: "superficie" },
        { text: "Prod(t/h)", value: "produzione" },
        { text: "TS", value: "temperatura" },
        { text: "Tes", value: "temperaturaEs" },
        { text: "Natura fluido", value: "naturaFluido" },
        { text: "Stato fluido", value: "statoFluido" },
        { text: "Gruppo fluido", value: "gruppoFluido" },
      ],
      headersAccessoriSicurezza: [
        { text: "Tipo", value: "tipo" },
        { text: "Costruttore", value: "costruttore" },
        { text: "Modello", value: "modello" },
        { text: "N.F./lotto", value: "nFab" },
        { text: "Taratura", value: "taratura" },
      ],
      headersDispositiviControllo: [
        { text: "Tipo", value: "tipo" },
        { text: "Modello", value: "modello" },
        { text: "Fondo scala", value: "fondoScala" },
        { text: "Segno Rosso", value: "segnoRosso" },
        { text: "Taratura", value: "taratura" },
      ],
      headersDispositiviRegolazione: [
        { text: "Tipo", value: "tipo" },
        { text: "Marca", value: "marca" },
        { text: "Modello", value: "modello" },
        { text: "Taratura", value: "taratura" },
        { text: "Note", value: "note" },
      ],
      rules: {
        required: (value) => (!!value ? true : "Campo richiesto!"),
        select: (value) => value != 0,
      },
      form: "",
      firmaDatore: "",
      riepilogo: {},
      dialogRiepilogo: false,
      isBadPayer:false,
    };
  },
  methods: {
    schedaPrecedente() {
      if (this.numeroScheda > 1) {
        this.numeroScheda = parseInt(this.numeroScheda) - 1;
      }
    },
    schedaSuccessiva() {
      if (this.numeroScheda < this.schedeTotali) {
        this.numeroScheda = parseInt(this.numeroScheda) + 1;
      } else {
        this.salvaReport();
      }
    },
    tornaAllaHome() {
      this.$router.push({ path: "/" });
    },
    resetSecondoVerificatore() {
      if (!this.secondaFirma) {
        this.verbale.ad_usersecondoverificatore_id = 0;
        this.verbale.ad_userterzoverificatore_id = 0;
      }
    },
    toISOStringUTC(datestr) {
      var tzoffset = new Date().getTimezoneOffset() * 60000;
      return new Date(new Date(datestr) - tzoffset).toISOString().slice(0, -1);
    },
    salvaVerbale() {
      //if (!this.$refs.validForm.validate()) return;
      this.saveDisabled = true;
      this.$store.commit("setProgressMessage", "Salvaggio verbale");
      this.$store.commit("setProgressLoading", true);
      let data = Object.assign({}, this.verbale);
      if (this.$refs.firmaDatore.isEmpty()) {
        data.firmaTitolareBase64 = null;
      } else {
        data.firmaTitolareBase64 = this.$refs.firmaDatore
          .saveSignature()
          .data.split(",")[1];
      }
      data.dataVerifica = this.toISOStringUTC(data.dataVerifica);
      let parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/aggiornaInserisciVerbaleGVR";
      console.log(parameters);
      console.log(data);
      this.$store.dispatch("callIdempiereRest", parameters).then(
        (response) => {
          console.log(response);
          if (response.data.fct_vergvr_id != 0) {
            this.riepilogo.nomeVerbale = response.data.nomeVerbale;
            this.riepilogo.dataVerifica = response.data.dataVerbale;
            this.riepilogo.dataProxFun = response.data.dataProxFun;
            this.riepilogo.dataProxInt = response.data.dataProxInt;
            this.riepilogo.dataProxIntg = response.data.dataProxIntg;
            this.dialogRiepilogo = true;
            console.log(this.riepilogo);

            this.$store.commit("setProgressMessage", "Download in corso...");
            var that = this;
            let item = response.data;
            let parameters = {};
            parameters.idempiereRestPath = "print/addPrintJob";
            let data = {};
            data.parameters = "{id:" + item.fct_vergvr_id + "}";
            data.nomeStampa = "Verbale GVR";
            parameters.data = data;

            var that = this;
            setTimeout(function () {
              that.$store.commit("setProgressMessage", null);
            }, 1000);

            this.$store
              .dispatch("callIdempiereRest", parameters)
              .then((response) => {
                console.log(response);
                if (response.data.hasOwnProperty("file")) {
                  const linkSource =
                    "data:application/pdf;base64," + response.data.file;
                  const downloadLink = document.createElement("a");
                  const fileName = item.nomeVerbale + ".pdf";

                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
                  setTimeout(function () {
                    that.$store.commit("setBozzaGVR", null);
                    that.$store.commit("setProgressMessage", null);
                    that.$store.commit("setProgressLoading", true);
                    that.saveDisabled = false;
                    that.$store.commit("setBozzaGVR", null);
                  }, 5000);
                } else {
                  this.$store.commit("setProgressMessage", null);
                  var errorMsg = "Stampa non riuscita";
                  if (response.data.hasOwnProperty("message")) {
                    errorMsg = errorMsg + "\n" + response.data.message;
                  }
                  this.$store.commit("setErrorMessage", errorMsg);
                }
              });
          } else {
            console.log();
            this.$store.commit("setProgressMessage", null);
            var errorMsg = "Salvataggio non riuscito";
            if (response.data.hasOwnProperty("message")) {
              errorMsg = errorMsg + "\n" + response.data.message;
            }
            this.$store.commit("setErrorMessage", errorMsg);
          }
        },
        (error) => {
          console.log(error);
          this.$store.commit("setProgressMessage", null);
          var errorMsg = "Salvataggio non riuscito";
          errorMsg = errorMsg + "\n" + error;
          this.$store.commit("setErrorMessage", errorMsg);
        }
      );
    },
    home() {
      this.$store.commit("setProgressMessage", null);
      this.$store.commit("setProgressLoading", true);
      this.saveDisabled = false;
      this.$router.push({ path: "/" });
    },
  },
  mounted: async function () {
    this.$store.commit("setProgressMessage", "Caricamento dati macchina...");
    this.$vuetify.lang.current = "it";
    let data = {};
    data.type = "tipologiaMacchinarioGVR";
    let parameters = {};
    parameters.data = data;
    parameters.idempiereRestPath = "vecos/getVerbalOptions";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipologiaMacchinario = response.data.opzioni;
      });
    parameters.data.type = "esito";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipoEsito = response.data.opzioni;
      });
    parameters.data.type = "tipoVerificaGVR";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipiVerifica = response.data.opzioni;
      });
    parameters.data.type = "tipoStatoVerificaGVR";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipoStatoVerifica = response.data.opzioni;
      });
    parameters.data.type = "tipoMacchinarioGVR";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.tipoMacchinario = response.data.opzioni;
      });
    parameters.data = {};
    parameters.idempiereRestPath = "vecos/getListaVerificatori";
    await this.$store
      .dispatch("callIdempiereRest", parameters)
      .then((response) => {
        this.listaVerificatori = response.data.listaVerificatori;
      });
    this.isBadPayer = this.$store.state.datiVerbale.isBadPayer;
    if (
      this.$store.state.datiVerbale.type == "C" ||
      this.$store.state.datiVerbale.type == "M"
    ) {
      data = {};
      data.fct_vergvr_id = this.$store.state.datiVerbale.fct_vergvr_id;
      parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/getVerbaleGVR";
      await this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          console.log(response);
          this.dataProxVerIntegrita =
            response.data.verbale.dataProxVerIntegrita;
          this.dataProxVerFunz = response.data.verbale.dataProxVerFunz;
          this.dataProxVerInterna = response.data.verbale.dataProxVerInterna;
          this.verbale = response.data.verbale;
          delete this.verbale.dataProxVerIntegrita;
          delete this.verbale.dataProxVerFunz;
          delete this.verbale.dataProxVerInterna;
          this.verbale.updateScad = true;
          console.log(this.verbale);
          if (this.$store.state.datiVerbale.type == "C") {
            this.verbale.fct_vergvr_id = 0;
            this.verbale.ad_usersecondoverificatore_id = 0;
            this.verbale.ad_userterzoverificatore_id = 0;
            this.firmaDatore = "";
            this.verbale.dataVerifica = new Date().toISOString().substr(0, 10);
            for (let index in this.verbale.generatori) {
              this.verbale.generatori[index].id_generatore = 0;
            }
            let liste = [
              "accessoriSicurezza",
              "dispositiviControllo",
              "dispositiviRegolazione",
            ];
            for (let lista of liste) {
              for (let index in this.verbale[lista]) {
                this.verbale[lista][index].id = 0;
              }
            }
            this.verbale.c_orderline_id = parseInt(
              this.$store.state.datiVerbale.c_orderline_id
            );
            this.verbale.fct_scadverifiche_id = parseInt(
              this.$store.state.datiVerbale.fct_scadverifiche_id
            );
            this.verbale.c_bpartner_id = parseInt(
              this.$store.state.datiVerbale.c_bpartner_id
            );
          } else {
            this.verbale.updateScad = false;
            if (this.verbale.ad_usersecondoverificatore_id != 0) {
              this.secondaFirma = true;
            }
            this.firmaDatore = this.verbale.firmaDatore;
          }
          delete this.verbale.firmaDatore;
        });
    } else {
      this.verbale.ad_userverificatore_id = this.$session.get("ad_user_id");
      data = {};
      data.fct_scadverifiche_id =
        this.$store.state.datiVerbale.fct_scadverifiche_id;
      parameters = {};
      parameters.data = data;
      parameters.idempiereRestPath = "vecos/getDatiMacchina";
      await this.$store
        .dispatch("callIdempiereRest", parameters)
        .then((response) => {
          let macchinario = response.data.macchinario;
          this.verbale.anno = macchinario.anno;
          this.verbale.comuneDitta = macchinario.comuneDitta;
          this.verbale.ditta = macchinario.ditta;
          this.verbale.marca = macchinario.costruttore;
          this.verbale.matricola = macchinario.matricolaInail;
          this.verbale.modello = macchinario.modello;
          this.verbale.nFab = macchinario.nFab;
          this.verbale.viaDitta = macchinario.viaDitta;
          this.verbale.luogoVerifica = macchinario.comuneDitta;
          this.verbale.tipoMacchinario = macchinario.tipoAttrezzatura;
          this.verbale.certCE = macchinario.certCE;
        });
      this.verbale.fct_scadverifiche_id = parseInt(
        this.$store.state.datiVerbale.fct_scadverifiche_id
      );
      this.verbale.c_bpartner_id = parseInt(
        this.$store.state.datiVerbale.c_bpartner_id
      );
      this.verbale.c_orderline_id = parseInt(
        this.$store.state.datiVerbale.c_orderline_id
      );
      this.verbale.fct_vergvr_id = 0;
    }
    this.$store.commit("setProgressMessage", null);
    console.log(this.$store.state.bozzaGVR);
    if (
      this.$store.state.bozzaGVR != null &&
      this.$store.state.bozzaGVR.verbale.fct_scadverifiche_id ==
        this.$store.state.datiVerbale.fct_scadverifiche_id &&
      this.$store.state.bozzaGVR.verbale.fct_vergvr_id ==
        this.$store.state.datiVerbale.fct_vergvr_id &&
      this.$store.state.datiVerbale.type == this.$store.state.bozzaGVR.type
    ) {
      this.$refs.confirm
        .open("Salvataggio", "Ripristinare il salvataggio automatico?", {
          color: "primary",
        })
        .then((confirm) => {
          if (confirm) {
            this.verbale = this.$store.state.bozzaGVR.verbale;
          } else {
            this.$store.commit("setBozzaGVR", null);
          }
          /*this.verbale.dataVerifica = new Date().toISOString().substr(0, 10);
          this.verbale.dataProssimaVerifica = new Date()
            .toISOString()
            .substr(0, 10);*/
        });
    } else {
      this.$store.commit("setBozzaGVR", null);
    }

    var that = this;
    setInterval(() => {
      let bozza = {};
      bozza.verbale = that.verbale;
      bozza.type = that.$store.state.datiVerbale.type;
      that.$store.commit("setBozzaGVR", bozza);
      console.log("salvataggio");
    }, 20000);
  },
  watch: {
    numeroScheda() {
      if (this.numeroScheda == this.schedeTotali && this.firmaDatore != "") {
        var that = this;
        setTimeout(function () {
          that.$refs.firmaDatore.fromDataURL(
            "data:image/png;base64," + that.firmaDatore
          );
        }, 10);
      }
    },
  },
  computed: {
    dataProssimaVerifica: function () {
      let anni = 1;
      switch (this.tipoVerifica) {
        case 1000005:
          anni = 2;
          break;
        case 1000007:
          anni = 6;
          break;
        case 1000006:
          anni = 1;
          break;
      }
      let dataProxVer = new Date(this.verbale.dataVerifica);
      dataProxVer.setFullYear(dataProxVer.getFullYear() + anni);
      return dataProxVer.toISOString().substr(0, 10);
    },
    esito: function () {
      if (this.tipoEsito.length < 1) return false;
      for (let element of this.tipoEsito) {
        if (element.id == this.verbale.esito) {
          return element.name == "Risulta adeguato ai fini della sicurezza";
        }
      }
      return false;
    },
  },
};
</script>

<style>
</style>